import type { IExercise } from '../exercises';

export const PERSONAL_EPISODE_05_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-personal-05-01",
    "name": "肩部热身",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "shoulder",
    "tips": ["弹力带直臂绕肩热身", "按教学控制动作节奏"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/d914b12fe9da4d8c55dacd94.mp4",
    "videoUrl": "/media/collections-20261008/videos/9c40ccb45b3e0016583217b8.mp4",
    "targetMuscles": ["肩袖肌群", "肩胛稳定肌群"],
    "difficulty": "beginner",
    "source": "私教跟练 · 第5期",
    "demoStatus": "ready",
    "isStretch": false,
  },
  {
    "id": "course-20261008-personal-05-02",
    "name": "Trx激活",
    "bodyPart": "warmup",
    "equipment": "trx",
    "subCategory": "shoulder",
    "tips": ["激活肩胛稳定肌", "动作匀速控制"],
    "sets": 2,
    "reps": "12",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "source": "私教跟练 · 第5期",
    "demoUrl": "/media/collections-20261008/demos/23fc9fbd7821da1a591362ef.mp4",
    "videoUrl": "/media/collections-20261008/videos/ccd3be7af509bd85a9d37a48.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
  },
  {
    "id": "course-20261008-personal-05-03",
    "name": "俯身哑铃肩伸后束",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "rear-delt",
    "tips": ["俯身角度稳定不晃", "感受后束挤压"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "私教跟练 · 第5期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-54c21f64fc40b8a874649d1c.mp4",
    "videoUrl": "/media/collections-20261008/videos/69b1c4553036766dec3de34e.mp4",
    "targetMuscles": ["三角肌后束"],
    "difficulty": "intermediate",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-05-04",
    "name": "坐姿反飞鸟后束",
    "bodyPart": "shoulders",
    "equipment": "machine",
    "subCategory": "rear-deltoid",
    "tips": ["肩胛骨后缩", "感受后束收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/6641ddd8bfc4c0319eae07b7.mp4",
    "videoUrl": "/media/collections-20261008/videos/cc029bcad3a62c9ed1a913a8.mp4",
    "targetMuscles": ["三角肌后束"],
    "difficulty": "beginner",
    "source": "私教跟练 · 第5期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-05-05",
    "name": "哑铃推肩",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "anterior-delt",
    "tips": ["核心收紧不顶腰", "推至头顶正上方"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "source": "私教跟练 · 第5期",
    "demoUrl": "/media/collections-20261008/demos/c1d19129f9f470a07ba881ff.mp4",
    "videoUrl": "/media/collections-20261008/videos/b3d543a31abf7ebd7cb2e8ec.mp4",
    "targetMuscles": ["三角肌前束", "三角肌中束", "肱三头肌"],
    "difficulty": "intermediate",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-05-06",
    "name": "哑铃侧平举中束",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "medial-delt",
    "tips": ["肘微屈，侧抬与肩齐平", "控制下放"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "私教跟练 · 第5期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-aae600906186eb89a5d6b58a.mp4",
    "videoUrl": "/media/collections-20261008/videos/65e4bde1f432d3f960a50276.mp4",
    "targetMuscles": ["三角肌中束"],
    "difficulty": "intermediate",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-05-07",
    "name": "哑铃前平举前束",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "front-deltoid",
    "tips": ["前平举刺激前束", "交替或双手"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-2fc24a5c88d51d3c6d7f9f4d.mp4",
    "videoUrl": "/media/collections-20261008/videos/d307fb328c96c41b8e913272.mp4",
    "targetMuscles": ["三角肌前束"],
    "difficulty": "intermediate",
    "source": "私教跟练 · 第5期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
];
